export const ACTIONS = {
  UPDATE_FRIENDS_LIST: "UPDATE_FRIENDS_LIST",
  UPDATE_FRIENDS_REQUEST: "UPDATE_FRIENDS_REQUEST",
  UPDATE_SENT_REQUEST: "UPDATE_SENT_REQUEST",
  CLOSE_BANNER: "CLOSE_BANNER",
  UPDATE_RECENT_SEARCH: "UPDATE_RECENT_SEARCH",
  SET_SORT_BY: "SET_SORT_BY",
};
